import React, { useEffect } from "react";
import { SidebarModal, Spinner } from "../../components";
import Update from "./components/update";
import Chat from "./Chat";
import "./components/form.scss";

function LeadChatUpdateModal({
  selected,
  updateModal,
  setSelected,
  showUpdateModal,
  chat,
  modelable_id,
  setModelableId,
  leadType,
  zIndex,
  loadingTitle,
}) {
  useEffect(() => {
    const fetchSelectedOrganization = async () => {
      if (chat && modelable_id) {
        try {
          const response = await fetch(
            `https://api-kafe.zim-zim.uz/api/v1/app/employee/leads/${modelable_id}?append=humanized_activities,type_of_activity&include=files,activities,region,district,source,status,contacts,user,users,organization&_f=json&_l=ru`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error("Request failed with status " + response.status);
          }

          const data = await response.json();
          setSelected(data);
        } catch (error) {
          console.error(error);
        }
      }
    };

    fetchSelectedOrganization();
  }, [chat, modelable_id]);

  return (
    <SidebarModal
      size={1350}
      isOpen={updateModal}
      zIndex={zIndex}
      toggle={() => {
        showUpdateModal(false);
        setSelected(null);
        if (setModelableId) setModelableId(null);
      }}
    >
      {selected ? (
        <div className="lead-modal">
          <div className="lead-modal__left w-full lg:w-1/2 px-2">
            <div className="update-form">
              <Update {...{ showUpdateModal, selected, leadType }} />
            </div>
          </div>

          <div className="lead-modal__right w-full lg:w-1/2 px-2">
            <Chat {...{ selected }} />
          </div>
        </div>
      ) : (
        <div className="mt-10" style={{ textAlign: "center" }}>
          {loadingTitle && (
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: "#1e293b",
                marginBottom: 10,
              }}
            >
              {loadingTitle}
            </div>
          )}
          <Spinner />
        </div>
      )}
    </SidebarModal>
  );
}

export default LeadChatUpdateModal;
